import { useSelector, useDispatch } from "react-redux";
import { ActionTypes } from "../store/types";
import { ReactComponent as RightArrow } from "../assets/icons/right-arrow.svg";
import plusSign from "../assets/icons/plus.png";
import { characters } from "../data/characters";
import scss from "./CharacterSelection.module.scss";

import { submitSquadSelection } from "../store/actions";

export const CharacterSelection = () => {
  const dispatch = useDispatch();
  const { selectedCharacters, loading } = useSelector((state: any) => state);

  const handleSubmit = async () => {
    if (selectedCharacters.length !== 5) {
      dispatch({
        type: ActionTypes.SET_MODAL,
        payload: {
          open: true,
          message: "You must select 5 characters for your squad",
        },
      });
      return;
    }
    dispatch(submitSquadSelection());
  };

  const SelectionCell = ({ index }) => {
    const id = selectedCharacters[index];
    return id ? (
      <div className={scss.character}>
        <img alt={characters[id].name} src={characters[id].icon} />
      </div>
    ) : (
      <div className={scss.empty}>
        <div>
          <img alt="" src={plusSign} />
        </div>
      </div>
    );
  };

  return (
    <div className={scss.bottomContainer}>
      <nav className={scss.bottomNav}>
        <div className={scss.currentSquad}>
          {["", "", "", "", ""].map((_, i) => {
            return <SelectionCell key={i} index={i} />;
          })}
        </div>
        <div className={scss.buttonWrapper}>
          <button disabled={loading} onClick={handleSubmit}>
            <RightArrow />
          </button>
        </div>
      </nav>
    </div>
  );
};
